export default __webpack_public_path__ + "static/media/IMG_1056cropped.136ea6ef.jpeg";